import React from "react";
import { getSortingClass, getTableStyles } from "../utils/withheldtable";
import { Link } from "react-router-dom";
import { formatAmount } from "../utils/format";
import PaginationButtons from "./PaginationButtons";

const WithheldTable = ({
  caseData,
  total,
  sortingColumns,
  handleSorting,
  user,
  withheldCheckboxes,
  handleWithheldTableCheckboxChange,
  page,
  prevPage,
  nextPage,
  pageSelected,
  openGalleryModal,
  openRemarksModal,
  openPayeeDetailModal,
}) => {
  const areAllCheckboxesChecked = () => {
    let isChecked = Object.keys(withheldCheckboxes).length === caseData.length;
    if (!isChecked) return false;
    for (const val of Object.values(withheldCheckboxes)) {
      if (!val.checked) return false;
    }
    return true;
  };
  return (
    <div role="tabpanel" className="tab-pane fade in active" id="mycase">
      <div>
        <div id="dtsMycase_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="dtsMycase"
            className="fmTableview display table table-bordered table-hover dataTable"
            cellSpacing="0"
            width="100%"
            role="grid"
            aria-describedby="dtsMycase_info"
          >
            <style>{getTableStyles()}</style>
            <thead>
              <tr role="row">
                <th
                  className="sorting_desc withheldlist-checkbox"
                  aria-label=""
                >
                  <input
                    type="checkbox"
                    className="withheld-panel-all-chkd"
                    id="chk"
                    name="selectall"
                    onChange={(e) => handleWithheldTableCheckboxChange(e, -1)}
                    checked={areAllCheckboxesChecked()}
                  />
                  <label htmlFor="chk">
                    <span className="dt-yes"></span>
                  </label>
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "lead_id"
                  )} withheldlist-lead-id`}
                  aria-controls="dtsMycase"
                  aria-label="Loan ID: activate to sort column ascending"
                  onClick={() => handleSorting("lead_id")}
                >
                  Loan ID
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "car_details"
                  )} withheldlist-car-details`}
                  aria-controls="dtsMycase"
                  aria-label="Car Details: activate to sort column ascending"
                  onClick={() => handleSorting("car_details")}
                >
                  Car Details
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "cus_name"
                  )} withheldlist-customer`}
                  aria-controls="dtsMycase"
                  aria-label="Customer Name: activate to sort column ascending"
                  onClick={() => handleSorting("cus_name")}
                >
                  Customer Name
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "city"
                  )} withheldlist-city`}
                  aria-controls="dtsMycase"
                  aria-label="City: activate to sort column ascending"
                  onClick={() => handleSorting("city")}
                >
                  City
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "ledger_balance"
                  )} withheldlist-ledger-balance`}
                  aria-controls="dtsMycase"
                  aria-label="Ledger Balance: activate to sort column ascending"
                  onClick={() => handleSorting("ledger_balance")}
                >
                  Ledger Balance
                </th>
                <th
                  className="sorting_disabled withheldlist-tranche-name"
                  aria-label="Tranche Name"
                >
                  Tranche Name
                </th>
                <th
                  className="sorting_disabled withheldlist-rc-status"
                  aria-label="RC Status"
                >
                  RC Status
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "withheld_amount"
                  )} withheldlist-withheld-amount`}
                  aria-controls="dtsMycase"
                  aria-label="Withheld Amount: activate to sort column ascending"
                  onClick={() => handleSorting("withheld_amount")}
                >
                  Withheld Amount
                </th>
                <th
                  className="sorting_disabled withheldlist-actual-charges"
                  aria-label="Actual Charges"
                >
                  Actual Charges
                </th>
                <th
                  className="sorting_disabled withheldlist-tranche-amount"
                  aria-label="Tranche Amount"
                >
                  Tranche Amount
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "rto_agent"
                  )} withheldlist-rto-agent`}
                  aria-controls="dtsMycase"
                  aria-label="RTO Agent: activate to sort column ascending"
                  onClick={() => handleSorting("rto_agent")}
                >
                  RTO Agent
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "pending_amount"
                  )} withheldlist-pending-amount`}
                  aria-controls="dtsMycase"
                  aria-label="Pending Amount: activate to sort column ascending"
                  onClick={() => handleSorting("pending_amount")}
                >
                  Pending Amount
                </th>
                <th className="sorting_disabled" style={{ width: "10%" }}></th>
              </tr>
            </thead>
            <tbody>
              {caseData.map((caseObj, idx) => {
                const {
                  finance_lead_id,
                  disbursement_id,
                  assign_lm,
                  name,
                  regno,
                  bank_name,
                  customer_name,
                  last_name,
                  lead_city,
                  current_balance,
                  rc_sub_stage,
                  trancheAmount,
                  rto_charges,
                  final_rto_charge,
                  sub_stage,
                  rcAgentName,
                  net_disbursement_amount,
                  lead_disbursed_amt,
                  total_paid_by_bank,
                  is_account_changes,
                  hold_status,
                } = caseObj;
                const netDisbAmount = net_disbursement_amount
                  ? net_disbursement_amount
                  : lead_disbursed_amt;
                const pendingAmount = formatAmount(
                  parseInt(netDisbAmount) -
                    parseInt(total_paid_by_bank ? total_paid_by_bank : "0")
                );
                const remarkCls = sub_stage === "4" ? "btn-danger" : "";
                const trancheCls =
                  +final_rto_charge > +rto_charges ? "col-red" : "";
                return (
                  <tr
                    role="row"
                    className={`${
                      idx % 2 === 1 ? "even" : "odd"
                    } withheld-table-row`}
                    key={finance_lead_id}
                  >
                    <td>
                      <div className=" bor-das car-savings tooltip-pos">
                        {+hold_status === 1 ? (
                          <div className="">
                            <div className="saving-details box-tooltip">
                              <div className="panel-body">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="tt-label">On Hold</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <input
                          title="onhold"
                          className="withheld-panel-chkd"
                          type="checkbox"
                          name="rto_charges_ckd"
                          id={`chk_${finance_lead_id}`}
                          value={finance_lead_id}
                          onChange={(e) =>
                            handleWithheldTableCheckboxChange(
                              e,
                              finance_lead_id
                            )
                          }
                          checked={
                            withheldCheckboxes[finance_lead_id]?.checked ||
                            false
                          }
                          disabled={+hold_status === 1}
                        />
                        <label
                          className="kkk"
                          htmlFor={`chk_${finance_lead_id}`}
                        >
                          <span className="dt-yes"></span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div className=" bor-das car-savings tooltip-pos">
                        {assign_lm ? (
                          <div className="">
                            <div className="saving-details box-tooltip">
                              <div className="panel-body">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="tt-label">{assign_lm}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        <Link
                          to={`/payments/details?lead_id=${btoa(
                            finance_lead_id
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="withheld-panel-lead-id"
                        >
                          {finance_lead_id}
                        </Link>
                      </div>
                    </td>
                    <td>
                      <div className=" bor-das car-savings tooltip-pos">
                        <div className="">
                          <div className="saving-details box-tooltip">
                            <div className="panel-body">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="tt-label">{name}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {regno}
                      </div>
                    </td>
                    <td>
                      <div className=" bor-das car-savings tooltip-pos">
                        <div className="">
                          <div className="saving-details box-tooltip">
                            <div className="panel-body">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="tt-label">{bank_name}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {`${customer_name} ${last_name}`}
                      </div>
                    </td>
                    <td>{lead_city}</td>
                    <td className="sorting_1">
                      {formatAmount(+current_balance)}
                    </td>
                    <td>RTO Charges</td>
                    <td>{rc_sub_stage}</td>
                    <td>{formatAmount(+rto_charges)}</td>
                    <td>
                      <div className={`${trancheCls}`}>
                        {formatAmount(+final_rto_charge)}
                      </div>
                    </td>
                    <td className="withheld-tranche-amt-cell">
                      <button
                        id={`tranche_amt_${finance_lead_id}`}
                        style={{ cursor: "pointer" }}
                        className="withheld-tranche-amt-button"
                        onClick={(e) => {
                          openPayeeDetailModal(finance_lead_id, sub_stage);
                          e.stopPropagation();
                        }}
                      >
                        {formatAmount(trancheAmount)}
                      </button>
                      {user.dts_user === "PLEAD" &&
                      +is_account_changes === 1 ? (
                        <>
                          (<span className="col-red">edited</span>)
                        </>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{rcAgentName ? rcAgentName : ""}</td>
                    <td>{pendingAmount}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-close-case"
                        title="View Gallery"
                        onClick={(e) => {
                          openGalleryModal(
                            finance_lead_id,
                            sub_stage,
                            customer_name,
                            last_name,
                            bank_name,
                            regno,
                            current_balance
                          );
                          e.stopPropagation();
                        }}
                      >
                        <span className="fa fa-picture-o withheld-gallery-icon"></span>
                      </button>
                      <button
                        className={`btn btn-sm btn-close-case ${remarkCls}`}
                        title="View Remarks"
                        onClick={(e) => {
                          openRemarksModal(
                            finance_lead_id,
                            disbursement_id,
                            sub_stage,
                            idx
                          );
                          e.stopPropagation();
                        }}
                      >
                        <span className="fa fa-exclamation-triangle withheld-remark-icon"></span>
                      </button>
                    </td>
                  </tr>
                );
              })}
              {!caseData.length ? (
                <tr className="odd">
                  <td valign="top" colSpan="14" className="dataTables_empty">
                    No data available in table
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
          <PaginationButtons
            page={page}
            total={total}
            prevPage={prevPage}
            nextPage={nextPage}
            pageSelected={pageSelected}
          />
        </div>
      </div>
    </div>
  );
};

export default WithheldTable;
